module.exports = "<p>\n  report-form works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/Pages/reports/report-form/report-form.component.html
// module id = ./src/app/Pages/reports/report-form/report-form.component.html
// module chunks = main